module.exports = __webpack_public_path__ + "static/media/slide2.284629c3.jpg";